import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbProps {
  items: { label: string; path?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.path ? `https://momfriends.cn${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbJsonLd)}
      </script>
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap text-sm text-foreground-500">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-2 text-foreground-400">/</span>
              )}
              {item.path ? (
                <Link
                  to={item.path}
                  className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium whitespace-nowrap">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}